import { PropsWithChildren } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

type LeftBarElementProps = {
  icon: IconDefinition;
  iconSelected: IconDefinition;
  path: string;
  startsWith?: string;
};

export function NavbarElementMobile({
  icon,
  iconSelected,
  path,
  children,
  startsWith,
}: PropsWithChildren<LeftBarElementProps>) {
  const location = useLocation();
  const isSelected = location.pathname.startsWith(startsWith ?? path);

  return (
    <Link
      to={path}
      className={`flex flex-col items-center gap-1 w-12 ${
        isSelected ? "text-primary" : "text-font-secondary"
      }`}
    >
      <div className="flex flex-col items-center gap-1">
        <div className="w-8 flex justify-center items-center">
          <FontAwesomeIcon
            className={clsx("text-xl", isSelected && "text-primary")}
            icon={isSelected ? iconSelected : icon}
          />
        </div>
        <div
          className={clsx(
            "text-font-secondary",
            "text-xs",
            isSelected && "text-primary font-medium",
          )}
        >
          {children}
        </div>
      </div>
    </Link>
  );
}
